<template>
    <div class="etermin-cacellation">
        <div class="m-auto vue-progress-bar">
            <vue-progress-bar></vue-progress-bar>
        </div>
        <div class="bg-secondary-l p-3 p-lg-10 border-radius-main">
            <div class="p-3 p-lg-12">
                <notification-container :appointement="generatedAppointement" />
                <div class="etermin-headline mb-6 text-center" v-if="generatedAppointement.externalid">
                    <h2 class="pb-1">{{ steps[id].title }}</h2>
                    <div>{{ steps[id].description }}</div>
                </div>
                <div class="vue-etermin-form w-100 h-100 position-relative pos normal-view" v-if="generatedAppointement.externalid">
                    <div class="etermin-overlay-wrapper">
                        <div class="row" v-if="generatedAppointement.calenderid">
                            <div class="block-item col-lg-6 col-sm-12 mb-5">
                                <div class="bg-white p-2 p-lg-5 border-radius-main shadow-2">
                                    <h3 class="mb-3">{{text.your_store}}</h3>
                                    <div class='loading-status mb-1' v-if="!selectedStore && selectedStore!==-1"></div>
                                    <div class="content bg-secondary-l border-radius-main p-2 p-lg-3 text-s" v-if="selectedStore || selectedStore===-1">
                                        <div class="px-1 mb-2"><a :href="selectedStore.path">{{ selectedStore.title }}</a></div>
                                        <div class="px-1">{{ selectedStore.address }}</div>
                                        <div class="px-1">{{ selectedStore.zip }} {{ selectedStore.city }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="block-item col-lg-6 col-sm-12 mb-5" v-if="generatedAppointement.calenderid">
                                <div class="bg-white p-3 p-lg-5 border-radius-main shadow-2">
                                    <h3 class="mb-2">{{text.date_time}}</h3>
                                    <div class="content bg-secondary-l border-radius-main p-2 p-lg-3 text-s">
                                        <div class="px-1">{{ generatedAppointement.start|date }}</div>
                                        <div class="px-1">{{ generatedAppointement.start|time }} - {{ generatedAppointement.end|time }} Uhr</div>
                                    </div>
                                </div>
                            </div>
                            <div class="block-item col-lg-6 col-sm-12 mb-5">
                                <div class="bg-white p-3 p-lg-5 border-radius-main shadow-2">
                                    <h3 class="mb-2">{{text.contact}}</h3>
                                    <div class='loading-status mb-1'  v-if="!selectedStore && selectedStore!==-1"></div>
                                    <div class="content bg-secondary-l border-radius-main p-2 p-lg-3 text-s"  v-if="selectedStore || selectedStore===-1">
                                        <div class="px-1">
                                            <a :href="'mailto:'+selectedStore.email" class="anchor-base hover mb-2">
                                                <div class="icon-wrapper border-radius-main no-overflow icon-sm me-2">
                                                    <svg class="icon-base">
                                                        <use xlink:href="/dist/icons/solid.svg#mail"></use>
                                                    </svg>
                                                </div>
                                                <span>{{selectedStore.email}}</span>
                                            </a>
                                        </div>
                                        <div class="px-1">
                                            <a :href="'tel:'+selectedStore.phone" class="anchor-base hover mb-2">
                                                <div class="icon-wrapper border-radius-main no-overflow icon-sm me-2">
                                                    <svg class="icon-base">
                                                        <use xlink:href="/dist/icons/solid.svg#phone"></use>
                                                    </svg>
                                                </div>
                                                <span>{{selectedStore.phone}}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="block-item col-lg-6 col-sm-12 mb-5 d-none" v-if="appointementDelai">
                                <div class="bg-white p-3 p-lg-5 border-radius-main shadow-2">
                                    <h3 class="mb-2">{{text.reason}}</h3>
                                    <div class="content bg-secondary-l border-radius-main p-2 p-lg-3 text-s">
                                        <textarea :placeholder="text.optional" rows="2" class="border-0 w-100 bg-secondary-l p-1" v-model="reasonleave"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Spinner :message ="loading.message" v-if="loading.status" class="mt-4" />
                        <div class="d-flex" v-if="appointementDelai && !loading.status && !generatedAppointement.deleted">
                            <div class="btn btn-primary align-center flex-lg-grow-0 flex-grow-1" v-if="selectedStore || selectedStore===-1" :data-store="selectedStore.title" @click="cancelAppointement(); gaSendEvent()">{{ text.cancel_btn }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nearest-app-store section-spacing-xl" v-if="selectedStore && selectedStore!==-1 && generatedAppointement.externalid">
            <nearest-stores :store="selectedStore"></nearest-stores>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import NotificationContainer from '@/components/NotificationContainer.vue'
import NearestStores from '@/components/NearestStores'
import moment from 'moment'
import 'moment-timezone'
import Spinner from 'vue-simple-spinner'

moment.locale('de')

export default {
    name: 'etermin-cancellation',
    components: {
        NotificationContainer,
        NearestStores,
        Spinner
    },
    watch: {
        progressLoadings: {
            deep: true,
            handler (loading) {
                if (loading.status) {
                    this.$Progress.start()
                } else {
                    if (loading.error) {
                        this.$Progress.fail()
                    } else {
                        this.$Progress.finish()
                    }
                }
            }
        },
        notifications: {
            deep: true,
            handler (notifications) {
                if (notifications.length > 0 && this.generatedAppointement.externalid) {
                    let options = {
                        container: 'body',
                        easing: 'ease-in',
                        offset: -100,
                        lazy: true,
                        force: true,
                        cancelable: true,
                        x: false,
                        y: true
                    }
                    this.$scrollTo('.etermin-cacellation', 500, options)
                }
            }
        }
    },
    computed: {
        notifications () { return this.$store.state.notification.notifications },
        appointementDelai () {
            if (this.$store.state.etermin.generatedAppointement.start) {
                let now = moment(new Date()).utc().format()
                let cancelLimit = moment(this.$store.state.etermin.generatedAppointement.rescheduleUntil).utc().format()
                if (moment(now).isAfter(moment(cancelLimit))) {
                    const notification = {
                        type: 'error',
                        message: Drupal.t('An appointment cancellation is only possible up to 1 hour before the start of the appointment.')
                    }
                    this.$store.dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    this.$store.dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                    this.$store.dispatch('stopLoading', null,
                        {
                            root: true
                        }
                    )
                    return false
                }
            }
            return true
        },
        progressLoadings () { return this.$store.state.loading },
        ...mapState({
            steps: state => state.etermin.steps,
            generatedAppointement: state => state.etermin.generatedAppointement
        }),
        ...mapState([
            'loading',
            'selectedStore'
        ])
    },
    filters: {
        time: function (value) {
            if (value) {
                let date = moment(value).utc().format()
                return moment.utc(date).tz('Europe/Berlin').format('H:mm')
            }
        },
        date: function (value) {
            let date = moment(value).utc().format()
            return moment.utc(date).tz('Europe/Berlin').format('dddd, DD. MMMM YYYY')
        }
    },
    data () {
        return {
            id: 4,
            externalid: null,
            accountId: null,
            reasonleave: '',
            text: {
                your_data: Drupal.t('Your data'),
                date_time: Drupal.t('Date & Time'),
                your_store: Drupal.t('Ihre Filiale'),
                contact: Drupal.t('Kontakt'),
                reason: Drupal.t('Stornierungsgrund'),
                optional: Drupal.t('Optional'),
                cancel_btn: Drupal.t('Termin stornieren')
            }
        }
    },
    methods: {

        cancelAppointement () {
            if (this.eventId) {
                this.$store.dispatch('etermin/deleteAppointement', {
                    store: this.selectedStore,
                    appid: this.generatedAppointement.externalid,
                    calenderid: this.selectedStore.calenderid
                })
            }
            else if (this.externalid) {
                this.$store.dispatch('etermin/deleteDeprecatedAppointement', {
                    store: this.selectedStore,
                    termin: this.generatedAppointement,
                    data: {
                        sendemail: 1,
                        sync: 1,
                        sendcopy: 1,
                        externalid: this.generatedAppointement.externalid,
                        services: this.generatedAppointement.services.join(),
                        reason: this.reasonleave
                    }
                })
            }
        },

        gaSendEvent () {
            // Google Tag-Manager push 'submit cancel a appointment' to dataLayer
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: `booking`,
                    event_type: `cancelled`,
                    event_data: {
                        store_name: this.selectedStore.title
                    }
                })
            }
        }
    },
    async mounted () {
        if (this.eventId) {
            await this.$store.dispatch('etermin/getAppointement', {
                appid: this.eventId,
                calenderid : this.companyId
            })
        }
        else if (this.externalid) {
            await this.$store.dispatch('etermin/getDeprecatedAppointement', {
                appid: this.externalid
            })
        }
        else {
            const notification = {
                type: 'error',
                message: Drupal.t('Appointement id is not specified.')
            }
            this.$store.dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            this.$store.dispatch('errorLoading', null,
                {
                    root: true
                }
            )
            this.$store.dispatch('stopLoading', null,
                {
                    root: true
                }
            )
        }
    },
    beforeMount () {
        const queryString = window.location.search
        let href = window.location.href
        if (href.includes('&amp;')){
            window.location.href = href.replace("&amp;", "&")
        }
        else{
            const urlParams = new URLSearchParams(queryString)
            this.eventId = urlParams.get('appointmentId')
            this.companyId = urlParams.get('companyId')
            this.externalid = urlParams.get('appID')
            this.accountId = urlParams.get('accountId')
            this.$store.dispatch('etermin/updateSteps', this.id)
        }
    }
}
</script>
